<template>
	<el-dialog title="录取通知书" :visible.sync="visible" :close-on-click-modal="false" @open="init()">
		<el-button class="edit_btn" type="primary" @click="download">下载录取通知书</el-button>
		<el-divider></el-divider>
		<p class="mb-20">
			如需申请纸质版录取通知书请填写收件信息<font color="#f00">（申请截止时间{{ mail_application_close_time }}）</font>
			<el-button class="edit_btn" type="primary" v-if="form_visible != true" @click="form_visible = true">{{enroll_btn_txt}}</el-button>
		</p>
		<div class="form_box" v-show="form_visible">
			<el-form v-loading="loading" autocomplete="off"
			:model="form"
			:rules="rules" ref="form_ref" label-width="80px">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="收件人" prop="name">
							<el-input type="text" v-model="profile.real_name" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="收件地址" prop="consignee_address">
							<el-input type="text" v-model="form.consignee_address"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号" prop="mobile">
							<el-input type="text" v-model="form.mobile"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="12">
					<el-button @click="form_visible = false">取 消</el-button>
					<el-button type="primary" @click="save_data()">保存</el-button>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<el-divider></el-divider>
		<el-table v-loading="loading" :data="my_mailing_list">
			<el-table-column property="real_name" label="姓名" width="80"></el-table-column>
			<el-table-column property="consignee_address" label="收件地址"></el-table-column>
			<el-table-column property="mobile" label="手机号" width="120"></el-table-column>
			<el-table-column property="shipper_company" label="邮寄单位" width="80"></el-table-column>
			<el-table-column property="courier_number" label="邮寄单号" width="140"></el-table-column>
		</el-table>
	</el-dialog>
</template>
    
<script>
export default {
	props: {
		profile: {
			type: Object,
			default: {
				real_name: "",
			}
		},
		user_id: {
			type: Number,
			default: 0
		},
		// xuejiInfoDisplay: {
		// 	type: Boolean,
		// 	default: true
		// },
		// getMyUserRelation: Function,
	}
	,components:{
	}
	,data () {
		return {
			loading: false,
			visible: false,
			form: {
				consignee_address: "",
				mobile: "",
			},
			rules: {
				consignee_address: [
					{ required: true, message: '请输入', trigger: 'blur' }
				],
				mobile: [
					{ required: true, message: '请输入手机号', trigger: 'blur' }
				],
			},
			my_mailing_id: 0,
			my_mailing_list: [],
			enroll_btn_txt: '编辑',
			form_visible: false,
		    serverSrc: this.global.serverSrc,
		    qianzui: this.global.qianzui,
			mail_application_close_time: '',
		}
	}
	,mounted:function(){
		// console.log(this.profile);
	}
	,methods:{
		init(){
			this.my_mailing_apply()
		},
		my_mailing_apply(){
			// 获取我的邮寄申请数据
			this.$ajax.get(this.serverSrc + this.qianzui + "/enroll_advice_note/my_mailing_apply")
			.then(res=>{
				let resData = res.data
				if(resData.code == 0){
					if(resData.data){
						let detail = resData.data.detail
						// 判断是否有提交过申请
						if(detail){
							this.my_mailing_id = detail.id
							this.form = {
								consignee_address: detail.consignee_address,
								mobile: detail.mobile,
							}
							this.my_mailing_list = [detail]
						}
						// 设置申请截止时间
						this.mail_application_close_time = resData.data.mail_application_close_end_time
					}else{
						this.enroll_btn_txt = '申请'
					}
				}
			})
		},
		download(){
			// 下载录取通知书
			this.$ajax.get(this.serverSrc + this.qianzui + "/user_archives/download",{
				params: {
					type_code: 'ADMISSION_NOTICE',
					user_relation_id: this.profile.user_relation_id,
				}
			})
			.then(res=>{
				let resData = res.data;
				if(resData.code == 0){
					window.open(resData.data.url)
				}
			})
		},
		save_data(){
			this.$refs.form_ref.validate((valid) => {
				if (valid) {
					let add_data = Object.assign({}, this.form, {
						id: this.my_mailing_id,
						user_relation_id: this.profile.user_relation_id,
						user_id: this.user_id,
						real_name: this.profile.real_name,
					})
					this.loading = true
					this.$ajax.post(
						this.serverSrc + this.qianzui + '/enroll_advice_note/save',
						this.$qs.stringify(add_data)
					).then((res)=>{
						this.loading = false
						let resData = res.data
						if(resData.code==0){
							this.$message.success('保存成功！');
							// 初始化表格数据
							this.init()
							// 隐藏表单
							this.form_visible = false
						}
					})
				}
			})
		}
	}
	,computed:{
	}
	,watch: {
	}
}
</script>


// WEBPACK FOOTER //
// src/components/userCenter/download_admission.vue